import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { RevenueReconciliationReportProvider } from "presentation/store/RevenueReconciliationReport/RevenueReconciliationReportProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import RevenueReconciliationReportMaintenance from "presentation/view/section/RevenueReconciliationReport/RevenueReconciliationReportMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const RevenueReconciliationReportContMain = () => {
    return <ANAInfoWrapper permission={Permission.REVENUE_RECONCILIATION_REPORT_MAINTENANCE}>
        <MessageBarWrapper>
            <RevenueReconciliationReportProvider>
                <GridStyles/>
                <RevenueReconciliationReportMaintenance/>
            </RevenueReconciliationReportProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default RevenueReconciliationReportContMain;